import Table, { Size } from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell, { TableCellProps } from "@material-ui/core/TableCell"
import TableRow from "@material-ui/core/TableRow"
import Typography from "@material-ui/core/Typography"
import React from "react"
import styled from "styled-components"

interface Rows {
  label: string
  data: Maybe<string>
}

interface IProps {
  rows: Array<Rows>
  size?: Size
  padding?: "checkbox" | "none" | "normal"
  addBorder?: boolean
}

type CellProps = TableCellProps & {
  addBorder?: boolean
}

const Cell = styled(({ addBorder, ...props }) => (
  <TableCell {...props} />
))<CellProps>`
  width: 50%;
  ${({ addBorder }) => !addBorder && `border-bottom: none;`};
`
const LeftCell = styled(Cell)`
  padding-right: ${({ theme }) => theme.spacing(2)}px;
`
const RightCell = styled(Cell)`
  padding-left: ${({ theme }) => theme.spacing(2)}px;
`

const Row: React.FC<{
  label: string
  data: Maybe<string>
  addBorder?: boolean
}> = ({ label, data, addBorder }) => (
  <TableRow>
    <LeftCell align="right" addBorder={addBorder}>
      <Typography style={{ fontWeight: "bold" }}>{label}</Typography>
    </LeftCell>
    <RightCell addBorder={addBorder}>
      <Typography>{data}</Typography>
    </RightCell>
  </TableRow>
)

const DataTable: React.FC<IProps> = ({
  rows,
  size = "small",
  padding = "none",
  addBorder,
}) => (
  <Table padding={padding} size={size}>
    <TableBody>
      {rows.map((row, i) => (
        <Row
          key={`${i}-${row.label}`}
          label={row.label}
          data={row.data}
          addBorder={i + 1 < rows.length ? addBorder : false}
        />
      ))}
    </TableBody>
  </Table>
)

export default DataTable
